module.exports = __webpack_public_path__ + "static/logo-45dbfed8786c28f9c5fcc80ba0d330ef.png";